import { AppState } from '../store';

export const getSystemSettings = (state: AppState) => state.settings.system;

export const getPollsSettings = (state: AppState) => state.settings.polls;

export const getUserSettings = (state: AppState) => state.settings.user;
